import React from 'react';
import Servicios from '../About/Servicios';
import { Container } from 'react-bootstrap';
import Desarrolloweb from './Desarrolloweb';
import Desarrolloapps from './Desarrolloapps';
import Manejoredes from './Manejoredes';
import Portfoliosweb from './Portfoliosweb';
import Alojamientoweb from './Alojamientoweb';
import Footer from '../Footer/Footer';
import { TypeAnimation } from 'react-type-animation';

const Serviciosprincipal = () => {
  return (
    <>
    <div className='separador'>
        <h3 className='colorini titulo-servicio'><TypeAnimation
        sequence={[
            "Servicios.",500,
          ]} 
          repeat={0}
        
        style={{ fontSize: '1.5em' }}/></h3></div>
<Container fluid>
    <Desarrolloweb/>
   {/* <Desarrolloapps/> */}
    <Alojamientoweb/>
{/*     <Manejoredes/> */}
    <Portfoliosweb/>
    


</Container>
<div className='separador-f'>
        <Footer/>
        </div>        
  </>
  
  )
}

export default Serviciosprincipal